import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { LazyComponent } from "./LazyComponent";
import "./LazyComponent.scss";

/*const ContentAreaBlock = React.lazy(() => import('../blocks/ContentAreaBlock'));*/
const RecommendationsBlock = React.lazy(() => import('../../ReactUS/Components/RecommendationsBlock/RecommendationsBlock'));
//const HTMLBlock = React.lazy(() => import('../blocks/HtmlBlock'));
//const PersonUsBlock = React.lazy(() => import('../Components/PersonUsBlock/PersonUsBlock'));
//const VideoUsBlock = React.lazy(() => import('../Components/VideoUsBlock/VideoUsBlock'));

//Bots
const isCrawler = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);

console.log("react-us-core-loaded and ready");

const blockTypes = [
    {
        name: "RecommendationsBlock",
        tagName: "ve-recommendations-block",
        component: RecommendationsBlock,
        LoadImmediately: false,
        template: ""
    },
    //{
    //    name: "HTMLBlock",
    //    tagName: "ve-htmlblock",
    //    component: HTMLBlock,
    //    LoadImmediately: false,
    //    template: ""
    //},
    //{
    //    name: "PersonUsBlock",
    //    tagName: "ve-contentareablock",
    //    component: PersonUsBlock,
    //    LoadImmediately: false,
    //    template: "PersonUsBlocks",
    //    IgnoreForCrawlers: true
    //},
    //{
    //    name: "VideoUsBlock",
    //    tagName: "ve-videousblock",
    //    component: VideoUsBlock,
    //    LoadImmediately: false,
    //}
]

export function processMarkup(rootElem = document) {
    //If it is a crawler, remove the blocks that are too slow to load.
    let blockTypesToRender = blockTypes;
    if (isCrawler) {
        blockTypesToRender = blockTypes.filter(block => {
            return typeof(block.IgnoreForCrawlers) == "undefined" || block.IgnoreForCrawlers == false;
        })
    }

    for (const block of blockTypesToRender) {
        var containers = rootElem.getElementsByTagName(block.tagName)
        if (block.template != null) {
            containers = Array.from(containers).filter(x => x.dataset.template == block.template)
        }
        for (const container of containers) {
            const root = createRoot(container);
            const { component, LoadImmediately } = block;
            root.render(
                <Suspense fallback={<div className="component-loading">Loading...</div>}>
                    <LazyComponent component={component} rootElement={container} loadImmediately={LoadImmediately} />
                </Suspense>
            );
        }
    }
}